$ ->
  $('button#app-upload-btn').on 'click', ->
    if $('#file-upload-form').hasClass('hidden')
      $('#file-upload-form').removeClass('hidden')
    else
      $('#file-upload-form').addClass('hidden')

  $(document).on 'cocoon:before-insert', '#edit_app_links_files', (e, insertedItem) ->
    num = $('.nested-fields.app-attachments').length
    divId = "att_#{num + 1}"
    nameInputId = "name-input-#{num + 1}"
    enableEditId = "enable-edit-name-#{num + 1}"
    insertedItem.attr('id', divId)
    insertedItem.find('div.name-input')
                .attr('id', nameInputId)
    insertedItem.find('.file-name-display label')
                .attr('for', enableEditId)
    insertedItem.find('input.enable-edit-name')
                .attr('id', enableEditId)
                .attr('data-target', nameInputId)


  $(document).on 'change', '.nested-fields.app-attachments .file-name .enable-edit-name', ->
    nameDisplay = $(this).closest('.file-name-display').find('.name-display')
    nameInput = $('#' + $(this).data('target'))
    if $(this).prop('checked')
      nameDisplay.toggleClass('in', false)
      nameInput.toggleClass('in', true)
    else
      inputValue = $(nameInput).find('input').val()
      nameDisplay.html(inputValue)
      nameDisplay.toggleClass('in', true)
      nameInput.toggleClass('in', false)

  ## Block enter from submitting
  $(document).on 'keypress', '.nested-fields.app-attachments .file-name .name-input input', (e)->
    if e.which == 13
      e.preventDefault()
      nameHeader = $(this).closest('.file-name').find('.name-display')
      headerValue = $(this).val()
      $(nameHeader).html(headerValue)

      collapseTrigger = $(this).closest('.file-name').find('.enable-edit-name')
      collapseTrigger.click()
      false
